<section id="page-content" class="product-page">
    <!-- Content-->
    <div class="container">
        <div class="product">
            <div class="row m-b-40">
                <div class="col-lg-5">
                    <div class="product-image">
                       <img alt="Nome immagine" src="{{datiProdotto?.img1}}">
                        <!-- Carousel slider - ->
                        <div class="carousel dots-inside dots-dark arrows-visible" data-items="1" data-loop="true" data-autoplay="true" data-animate-in="fadeIn" data-animate-out="fadeOut" data-autoplay="2500" data-lightbox="gallery">
                            <a href="images/shop/products/product-large.jpg" data-lightbox="image" title="Shop product image!"><img alt="Nome immagine" src="img-prodotti/8000630719510_1.png">
                            </a>
                            <a href="img-prodotti/8000630719510_1.png" data-lightbox="image" title="Shop product image!"><img alt="Nome immagine" src="img-prodotti/8000630719510_1.png">
                            </a>
                        </div>
                        <!- - Carousel slider -->
                    </div>
                </div>
                <div class="col-lg-7">
                    <div class="product-description">
                        <div class="product-category">{{datiProdotto?.categoria}}</div>
                        <h1>{{datiProdotto?.titolo}}</h1>
                        <div class="product-title">
                            <span>EAN: {{datiProdotto?.ean}}</span>
                        </div>
                        <br clear="all">
                        <div class="product-title">
                            <span>Listino: {{datiProdotto?.tipolist}}</span>
                        </div>
                        
                        <div class="product-price" *ngIf="loggato">
                            <img src="./assets/images/Semaforo-arancio.png" class="img-disp" alt="Prodotto disponibile" *ngIf="datiProdotto?.disponibilita >= 1 && datiProdotto?.disponibilita <= 10">
                            <img src="./assets/images/Semaforo-verde.png" class="img-disp" alt="Prodotto disponibile" *ngIf="datiProdotto?.disponibilita > 10">
                            <img src="./assets/images/Semaforo-rosso.png" class="img-disp" alt="Prodotto disponibile" *ngIf="datiProdotto?.disponibilita == 0">
                        
                            <ng-container *ngIf="datiProdotto?.InPromo != 0">
                                &nbsp;<ins> € {{datiProdotto?.prezzoPromo}} <span *ngIf="estero != 'SI'">(€ {{datiProdotto?.prezzoPromoIvato}})</span></ins>
                            </ng-container>

                            <ng-container *ngIf="datiProdotto?.InPromo == 0">
                                &nbsp;<ins>€ {{datiProdotto?.prezzo}} <span *ngIf="estero != 'SI'">(€ {{datiProdotto?.prezzoIvato}})</span></ins>
                            </ng-container>
                            
                        </div>
                    
                        <div class="seperator m-b-10"></div>
                        <p>{{datiProdotto?.descrizione}}</p>
                        <div class="product-meta">
                            <h4>Dati logistici</h4>
                            <p>Peso: <strong>{{datiProdotto?.peso}} kg</strong><br>
                                    Cartone: <strong>{{datiProdotto?.cartone}} pz</strong><br>
                                    Misure: <strong>{{datiProdotto?.misure}}</strong><br>
                                    Strati: <strong>{{datiProdotto?.strati}} cartoni</strong><br>
                                    Pedana: <strong>{{datiProdotto?.pedana}} cartoni</strong><br>
                            </p>
                        </div>
                        <div class="seperator m-t-20 m-b-10"></div>
                    </div>
                    <div class="row">
                        <!-- div class="col-lg-6">
                            <h6>Scegli la taglia</h6>
                            <ul class="product-size">
                                <li>
                                    <label>
                                        <input type="radio" checked="checked" value="option1" name="product-size"><span>128GB</span>
                                    </label>
                                </li>
                                <li>
                                    <label>
                                        <input type="radio" checked="checked" value="option1" name="product-size"><span>256GB</span>
                                    </label>
                                </li>
                                <li>
                                    <label>
                                        <input type="radio" checked="checked" value="option1" name="product-size"><span>512GB</span>
                                    </label>
                                </li>
                            </ul>
                        </div -->
                        <div class="col-lg-6" *ngIf="datiProdotto?.vendibile == 1">
                            <h6>Sleziona quantità</h6>
                            <div class="cart-product-quantity">
                                <div class="quantity m-l-5">
                                    <input type="button" class="minus" value="-" (click)="removeQty()">
                                    <input type="text" class="qty" [(ngModel)]="qty">
                                    <input type="button" class="plus" value="+" (click)="addQty()">
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <a class="btn btn-bg mt-3" (click)="addCart(datiProdotto)" *ngIf="loggato && datiProdotto?.vendibile == 1"><i class="icon-shopping-cart"></i> Aggiungi al carrello</a>
                            <a class="btn btn-bg mt-3 btn-danger" routerLink="/accedi" *ngIf="!loggato">ACCEDI</a>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <!-- <div class="heading-text heading-line text-center">
            <h4>Potrebbero interessarti...</h4>
        </div>
        
        <div class="shop">
    <div class="row correlati">
        <app-prodotti [arrProdotti]="listaProdottiCorrelati" [titolo]="titoloProd" [numCol]="3"></app-prodotti>
    </div>
</div>      -->

    <!-- end: Content-->
</div>
</section>